import type { Site, SiteStatus } from '@/lib/types';

function isOverseas(site: Site): boolean {
  return site.siteCategory.startsWith('해외');
}

/** 현장 묶음과 그 차례 — front `siteStatusData.SITE_SECTIONS` 와 같은 값이다. */
export const SITE_SECTIONS: Array<{
  key: string;
  label: string;
  status: SiteStatus;
  match: (site: Site) => boolean;
}> = [
  { key: 'domestic', label: '국내 진행', status: '진행', match: (site) => site.status === '진행' && !isOverseas(site) },
  { key: 'overseas', label: '해외 진행', status: '진행', match: (site) => site.status === '진행' && isOverseas(site) },
  { key: 'pending', label: '예정', status: '미진행', match: (site) => site.status === '미진행' },
  { key: 'evaluating', label: '평가', status: '평가', match: (site) => site.status === '평가' },
  { key: 'completed', label: '준공', status: '준공', match: (site) => site.status === '준공' },
];
